"use strict";
/**
 * RedPanda SaaS - Common Locales
 * 統一的共用翻譯導出
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonLocales = exports.lineJA = exports.lineEN = exports.lineZH = exports.resourceLimitJA = exports.resourceLimitEN = exports.resourceLimitZH = exports.dataIOJA = exports.dataIOEN = exports.dataIOZH = exports.modalJA = exports.modalEN = exports.modalZH = exports.staticContentJA = exports.staticContentEN = exports.staticContentZH = exports.commonJA = exports.commonEN = exports.commonZH = void 0;
// 導入翻譯 JSON 檔案
const common_json_1 = __importDefault(require("./locales/zh/common.json"));
exports.commonZH = common_json_1.default;
const common_json_2 = __importDefault(require("./locales/en/common.json"));
exports.commonEN = common_json_2.default;
const common_json_3 = __importDefault(require("./locales/ja/common.json"));
exports.commonJA = common_json_3.default;
const static_content_json_1 = __importDefault(require("./locales/zh/static-content.json"));
exports.staticContentZH = static_content_json_1.default;
const static_content_json_2 = __importDefault(require("./locales/en/static-content.json"));
exports.staticContentEN = static_content_json_2.default;
const static_content_json_3 = __importDefault(require("./locales/ja/static-content.json"));
exports.staticContentJA = static_content_json_3.default;
const modal_json_1 = __importDefault(require("./locales/zh/modal.json"));
exports.modalZH = modal_json_1.default;
const modal_json_2 = __importDefault(require("./locales/en/modal.json"));
exports.modalEN = modal_json_2.default;
const modal_json_3 = __importDefault(require("./locales/ja/modal.json"));
exports.modalJA = modal_json_3.default;
const dataIO_json_1 = __importDefault(require("./locales/zh/dataIO.json"));
exports.dataIOZH = dataIO_json_1.default;
const dataIO_json_2 = __importDefault(require("./locales/en/dataIO.json"));
exports.dataIOEN = dataIO_json_2.default;
const dataIO_json_3 = __importDefault(require("./locales/ja/dataIO.json"));
exports.dataIOJA = dataIO_json_3.default;
const resourceLimit_json_1 = __importDefault(require("./locales/zh/resourceLimit.json"));
exports.resourceLimitZH = resourceLimit_json_1.default;
const resourceLimit_json_2 = __importDefault(require("./locales/en/resourceLimit.json"));
exports.resourceLimitEN = resourceLimit_json_2.default;
const resourceLimit_json_3 = __importDefault(require("./locales/ja/resourceLimit.json"));
exports.resourceLimitJA = resourceLimit_json_3.default;
const line_json_1 = __importDefault(require("./locales/zh/line.json"));
exports.lineZH = line_json_1.default;
const line_json_2 = __importDefault(require("./locales/en/line.json"));
exports.lineEN = line_json_2.default;
const line_json_3 = __importDefault(require("./locales/ja/line.json"));
exports.lineJA = line_json_3.default;
// 統一的翻譯資源物件
exports.commonLocales = {
    zh: {
        common: common_json_1.default,
        staticContent: static_content_json_1.default,
        modal: modal_json_1.default,
        dataIO: dataIO_json_1.default,
        resourceLimit: resourceLimit_json_1.default,
        line: line_json_1.default
    },
    en: {
        common: common_json_2.default,
        staticContent: static_content_json_2.default,
        modal: modal_json_2.default,
        dataIO: dataIO_json_2.default,
        resourceLimit: resourceLimit_json_2.default,
        line: line_json_2.default
    },
    ja: {
        common: common_json_3.default,
        staticContent: static_content_json_3.default,
        modal: modal_json_3.default,
        dataIO: dataIO_json_3.default,
        resourceLimit: resourceLimit_json_3.default,
        line: line_json_3.default
    }
};
